import { Box, HStack, Text, SimpleGrid, Icon } from '@chakra-ui/react';
import { FiCheck, FiClock, FiUsers, FiMapPin, FiHome } from 'react-icons/fi'
import { formatEstimatedMinutes } from './turfEstimate'

interface TurfMapStatsRowProps {
  totalContactCount: number
  totalHouseholdCount: number
  turfCount: number
  totalVisitedCount: number
  /** Sum of routed turf estimates; null when no turf has been routed yet (renders "—", not "0 min"). */
  estimatedMinutes: number | null
}

export function TurfMapStatsRow({
  totalContactCount,
  totalHouseholdCount,
  turfCount,
  totalVisitedCount,
  estimatedMinutes,
}: TurfMapStatsRowProps) {
  const progressPercent =
    totalContactCount > 0
      ? Math.round((totalVisitedCount / totalContactCount) * 100)
      : 0

  return (
    <Box bg="surface" p={6} borderRadius="lg" shadow="md">
      <SimpleGrid columns={{ base: 2, md: 5 }} gap={4}>
        <Box>
          <HStack gap={2} color="gray.500" mb={1}>
            <Icon asChild><FiUsers /></Icon>
            <Text fontSize="xs" fontWeight="medium" textTransform="uppercase">
              Total Contacts
            </Text>
          </HStack>
          <Text fontWeight="bold" fontSize="lg">
            {totalContactCount.toLocaleString()}
          </Text>
        </Box>
        <Box>
          <HStack gap={2} color="gray.500" mb={1}>
            <Icon asChild><FiHome /></Icon>
            <Text fontSize="xs" fontWeight="medium" textTransform="uppercase">
              Households
            </Text>
          </HStack>
          <Text fontWeight="bold" fontSize="lg">
            {totalHouseholdCount.toLocaleString()}
          </Text>
        </Box>
        <Box>
          <HStack gap={2} color="gray.500" mb={1}>
            <Icon asChild><FiMapPin /></Icon>
            <Text fontSize="xs" fontWeight="medium" textTransform="uppercase">
              Turf Count
            </Text>
          </HStack>
          <Text fontWeight="bold" fontSize="lg">
            {turfCount}
          </Text>
        </Box>
        <Box>
          <HStack gap={2} color="gray.500" mb={1}>
            <Icon asChild><FiCheck /></Icon>
            <Text fontSize="xs" fontWeight="medium" textTransform="uppercase">
              Completion
            </Text>
          </HStack>
          <Text fontWeight="bold" fontSize="lg">
            {progressPercent}%
            <Text as="span" fontSize="sm" color="gray.400" ml={1}>
              ({totalVisitedCount}/{totalContactCount})
            </Text>
          </Text>
        </Box>
        <Box>
          <HStack gap={2} color="gray.500" mb={1}>
            <Icon asChild><FiClock /></Icon>
            <Text fontSize="xs" fontWeight="medium" textTransform="uppercase">
              Est. Time
            </Text>
          </HStack>
          <Text fontWeight="bold" fontSize="lg">
            {formatEstimatedMinutes(estimatedMinutes)}
          </Text>
        </Box>
      </SimpleGrid>
    </Box>
  );
}
